import { render, staticRenderFns } from "./ShowPopular.vue?vue&type=template&id=56731cb4&scoped=true&"
import script from "./ShowPopular.vue?vue&type=script&lang=js&"
export * from "./ShowPopular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56731cb4",
  null
  
)

export default component.exports